import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

import payMixin from "~/mixins/band/payin/pay"

const initialState = function () {
  return {
    order_id: 0,
    email: "",
  }
}

export const state = function () {
  return {
    ...initialState(),
    client_id: 0,
  }
}

export const mutations = {
  SET_CLIENT_ID: function (state, newid) {
    state.client_id = newid
  },
  SET_ORDER_ID: function (state, new_order_id) {
    if (typeof new_order_id === "number") state.order_id = new_order_id
    else state.order_id = 0
  },
  SET_EMAIL: function (state, new_email) {
    state.email = new_email
  },
  ...resetMixin.mutations,
}

export const actions = {
  PREFLIGHT_ROUTINE: function ({ rootState, rootGetters, commit }, { origin }) {
    const url = "/paypal-v2/payment-context/"
    const payload = {
      user: rootState.user.id,
      legal_data: rootState.payin.billing_infos.legal_data.id,
      value:
        rootGetters["payin/PURCHASE_TYPE"] === "unitary_pack"
          ? rootGetters["payin/FINAL_CREDITS_PURCHASE_AMOUNT"]
          : undefined,
      draft:
        rootState.draft.id &&
        rootGetters["payin/PURCHASE_TYPE"] === "sendtrack" &&
        !rootState.payin.packs.selected
          ? rootState.draft.id
          : undefined,
      pack: rootState.payin.packs.selected || undefined,
      kind: rootGetters["payin/PURCHASE_TYPE"],
      origin: process.client
        ? origin ?? window.location.pathname
        : "server_side",
    }
    return new Promise((resolve, reject) => {
      payMixin.methods.lock_safeguard(
        async function () {
          await this.$axios
            .$post(url, payload)
            .then((context_data) => {
              context_data.cost = parseFloat(context_data.cost)
              context_data.groovies = parseFloat(context_data.groovies)
              commit("SET_ORDER_ID", context_data.id)
              resolve(context_data)
            })
            .catch((err) => {
              reject(err)
              console.error(err)
            })
        }.bind(this)
      )
    })
  },
  RESET: function ({ commit }) {
    commit("RESET", initialState())
  },
}

export const getters = {
  IS_READY: function (state) {
    return (
      state.settings &&
      state.settings.mode !== null &&
      state.settings.client_id !== null
    )
  },
  PAYMENT_DATA: function (state, getters, rootState, rootGetters) {
    return {
      purchase_units: [
        {
          amount: {
            value: (
              rootGetters["payin/FINAL_PURCHASE_AMOUNT"] + 1.5
            ).toString(),
            currency_code: "EUR",
          },
          custom_id: state.order_id.toString(),
          reference_id: "reference",
        },
      ],
    }
  },
  READY_TO_CONFIRM: function (state) {
    return state.email.length > 0
  },
}
